import React, { Component } from 'react'
import { signIn } from "src/authConfig";
import { SFDC_DOMAIN } from 'src/Config/constants';

export class SfdcLogin extends Component {
  componentWillMount() {
    signIn(SFDC_DOMAIN ,false);
  }
  render() {
    return (
      <div>

      </div>
    )
  }
}

export default SfdcLogin;
